import { Badge, Box, Divider, Flex, Text, useColorModeValue, useDisclosure, VStack } from '@chakra-ui/react';
import { IoIosArrowDropdown } from 'react-icons/io';
import { memo } from 'react';
import { IExemptions } from '../../../../../services/hooks/CandidateArea/useRequestMyExemption';
import MoreDetailExemptionMobilePage from './moreDetail';
import LabelWithValueMobilePage from '../../../../../components/Mobile/labelWithValue';

export interface IResourceItem {
  id: string;
  code?: string;
  createdAt?: string;
  question?: string;
  status: string;
}

interface IOwnProps {
  item: IExemptions;
}

const CardDetailExemptionMobilePage: React.FC<IOwnProps> = ({ item }) => {
  const cardBg = useColorModeValue('white', 'gray.700');
  const { isOpen, onToggle } = useDisclosure();

  const statusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case 'deferido':
        return 'green';
      case 'em análise':
        return 'yellow';
      case 'indeferido':
        return 'red';
      case 'parecer publicado':
        return 'orange';
      default:
        return 'gray';
    }
  };

  return (
    <Box px={4} py={2} bg={cardBg} borderRadius="md" shadow="md" w="100%">
      <Flex justifyContent="space-between" alignItems="center">
        <VStack alignItems="initial" spacing={0}>
          <LabelWithValueMobilePage label="Tipo de solicitação" value={item.type} />
          <Text fontSize="0.7rem" color="gray.500">
            Enviado em: {item.created_at}
          </Text>
        </VStack>
        <VStack spacing={4} height="100%">
          <Badge fontSize="x-small" px={2} colorScheme={statusColor(item.status)}>
            {item.status}
          </Badge>
        </VStack>
      </Flex>
      <MoreDetailExemptionMobilePage
        dataToExemption={{
          status: item.status,
          attachments: item.attachments,
          justification: item.detail,
        }}
        isOpen={isOpen}
      />
      <Divider my={2} color="gray.400" />
      <Flex gap={1} cursor="pointer" onClick={onToggle} justifyContent="center" alignItems="center">
        <Box transform={`rotate(${isOpen ? 180 : 0}deg)`} transition="transform 0.3s ease">
          <IoIosArrowDropdown />
        </Box>
        <Text>Mostrar {isOpen ? 'menos' : ''} detalhes</Text>
      </Flex>
    </Box>
  );
};

export default memo(CardDetailExemptionMobilePage);
